var _circle, _rect, _line, _circle2, _circle3, _circle4, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _mask, _path28, _path29, _line19, _line20, _line21, _line22, _mask2, _path30, _path31, _path32;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateHtmlPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 193,
    viewBox: "0 0 179 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 98,
    r: 82,
    fill: "#E4E5E8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 0.5,
    width: 140,
    height: 114,
    rx: 3.5,
    fill: "white",
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 18.5,
    x2: 160,
    y2: 18.5,
    stroke: "#050C26"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 10,
    r: 4.5,
    stroke: "#050C26"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 10,
    r: 4.5,
    stroke: "#050C26"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 10,
    r: 4.5,
    stroke: "#050C26"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 30,
    x2: 43,
    y2: 30,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 37.5,
    x2: 69.5,
    y2: 37.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 32.5,
    y1: 51.5,
    x2: 43.5,
    y2: 51.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 57.5,
    x2: 70.5,
    y2: 57.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 75.5,
    y1: 57.5,
    x2: 86.5,
    y2: 57.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 90.5,
    y1: 57.5,
    x2: 109.5,
    y2: 57.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 57,
    x2: 135,
    y2: 57,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 45.5,
    x2: 65.5,
    y2: 45.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 74.5,
    y1: 45.5,
    x2: 91.5,
    y2: 45.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 98.5,
    y1: 45.5,
    x2: 109.5,
    y2: 45.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 23,
    y2: -1,
    transform: "matrix(-1 0 0 1 127 79)",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 97.5,
    y1: 78.5,
    x2: 84.5,
    y2: 78.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 78.5,
    y1: 78.5,
    x2: 57.5,
    y2: 78.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 74.5,
    y1: 37.5,
    x2: 85.5,
    y2: 37.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 91,
    y1: 37,
    x2: 112,
    y2: 37,
    stroke: "#050C26",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 118.5,
    y1: 37.5,
    x2: 125.5,
    y2: 37.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 130.5,
    y1: 37.5,
    x2: 140.5,
    y2: 37.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1706 132.757C58.5487 134.476 61.059 136.196 63.7014 137.65C74.9316 143.999 87.7472 147.57 101.488 147.57C105.319 147.57 109.151 147.306 112.982 146.777C115.625 145.19 116.814 143.47 116.682 141.883V141.751C116.682 141.618 116.682 141.486 116.549 141.486C114.964 137.121 95.0138 127.598 95.0138 127.598L56.1706 132.757Z",
    fill: "#050C26",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.175 105.774C128.175 105.774 115.491 129.317 103.997 128.524C86.1606 127.201 103.6 116.885 104.525 113.578C106.507 106.171 113.377 103.394 113.377 103.394L128.175 105.774Z",
    fill: "#050C26",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.98 184.34C166.49 184.34 168.868 183.414 170.85 181.695C175.078 177.859 175.474 171.246 171.643 167.013L107.961 94.4C104.262 90.0353 97.6557 89.7708 93.5599 93.6064C89.3321 97.4421 88.9357 104.055 92.7672 108.288L156.449 180.901C157.374 181.959 158.563 182.885 159.884 183.414C161.073 184.075 162.527 184.34 163.98 184.34Z",
    fill: "white",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.732 128.522C109.282 119.66 116.812 112.121 125.797 106.963L127.778 105.772L98.9762 74.1611L74.7982 97.0429L103.732 128.522Z",
    fill: "white",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8788 88.8432L37.2752 107.36V108.683V111.593V113.048C38.2 114.37 39.1249 115.693 40.0497 117.016C44.5418 122.967 49.9587 128.258 55.9041 132.623C58.2823 134.342 60.7925 136.062 63.4349 137.517C69.1161 136.062 74.9294 135.136 80.8748 134.871C92.3692 134.342 107.695 132.358 116.415 141.617L116.283 141.22L114.697 133.549L112.848 124.819L111.394 118.206L108.752 106.038L105.978 92.8111L103.864 83.0235C103.732 81.1718 103.203 79.4524 102.41 77.9975C100.032 73.236 94.8795 70.0616 89.3304 70.5907L76.3827 71.6488L60.9246 72.9714L59.9998 73.1037H59.8677L48.7696 74.0296C47.3163 74.1618 45.863 74.5586 44.5418 75.0877C41.503 76.4103 38.9927 78.9233 37.6715 81.9654C37.0109 84.0817 36.6146 86.4624 36.8788 88.8432Z",
    fill: "#898D9A",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3686 91.2249C29.0862 97.5735 31.7285 103.525 34.8994 109.081C35.56 110.271 36.2206 111.461 37.0133 112.519L37.4097 111.594L38.0703 110.006L37.2776 108.684L36.7491 107.758L27.6328 91.2249H27.3686Z",
    fill: "#050C26",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8366 89.3749C26.9687 90.0362 27.1009 90.5653 27.3651 91.2266C29.0827 97.5753 31.7251 103.527 34.8959 109.082C35.5565 108.685 36.2171 108.156 36.7456 107.76C36.8777 107.627 37.0099 107.495 37.2741 107.363C42.8231 103.395 46.1261 100.485 46.6546 100.088C50.8824 96.2526 51.2788 89.7717 47.5794 85.4069C46.6546 84.3488 45.5976 83.5552 44.4086 82.8939C43.2195 82.2326 41.8983 81.9681 40.5771 81.8358C39.6523 81.7035 38.8595 81.8358 37.9347 81.9681C37.5383 82.1003 37.0099 82.1003 36.6135 82.3648C35.2923 82.7616 34.1032 83.5552 33.1784 84.3488C33.0462 84.4811 30.8002 86.4651 26.8366 89.3749Z",
    fill: "white",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8239 78.1307C38.5984 76.279 41.6372 75.2209 44.808 75.0886C50.3571 74.8241 56.0382 77.4694 59.4734 82.4954C64.7582 90.299 62.9085 101.145 55.2455 106.435L40.316 117.016C34.6035 108.847 21.2551 102.164 19.5 92.5L35.8239 78.1307ZM58.2843 58.8201C58.4164 58.5556 58.5485 58.4233 58.8128 58.4233L60.134 58.1588L73.4781 56.0425C73.8744 55.9103 74.2708 56.3071 74.4029 56.7039L76.1205 67.9463L76.649 71.3852V71.5175C77.1774 75.8822 74.2708 79.8501 70.043 80.5115L69.2502 80.6437C64.8903 81.3051 60.9267 78.263 60.2661 74.0305L60.134 73.1047L59.2091 66.756C59.2091 66.4914 59.2091 66.3592 59.077 66.0946L58.02 59.3492C58.1522 59.2169 58.1522 59.0846 58.2843 58.8201Z",
    fill: "white",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6185 54.0963C58.2509 54.2873 57.8832 54.4783 57.3318 54.8602V54.6693C56.7803 53.1414 56.4126 51.6135 56.2288 50.0856C55.8612 47.6028 55.8612 45.502 56.2288 43.2102C58.6185 43.5922 60.4568 45.693 61.0083 48.1758C61.3759 50.6586 60.273 52.9504 58.6185 54.0963Z",
    fill: "#050C26",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3752 67.4618C74.2336 67.8335 76.4636 67.8335 78.5078 67.4618C89.1005 65.7892 96.534 55.5678 94.8615 44.7888C93.1889 34.0098 83.1538 26.3902 72.5611 28.0628C68.8444 28.6203 65.3135 30.2929 62.5259 32.8947C59.7384 35.4965 57.6942 38.8418 56.765 42.5586C56.2075 42.3728 55.4641 42.3728 54.9066 42.3728C52.1191 42.9303 49.889 45.718 50.4465 48.5057C50.8182 51.4792 53.6058 53.5235 56.5792 52.966C56.765 52.966 56.765 52.966 56.9508 52.7801C57.1367 53.3376 60.4817 73.9664 60.4817 73.9664L72.3752 67.4618Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3753 67.4618C74.2336 67.8335 76.4636 67.8335 78.5078 67.4618C89.1005 65.7892 96.534 55.5678 94.8615 44.7888C93.1889 34.0098 83.1538 26.3902 72.5611 28.0628C68.8444 28.6203 65.3135 30.2929 62.5259 32.8947C59.7384 35.4965 57.6942 38.8418 56.765 42.5586C56.2075 42.3728 55.4641 42.3728 54.9066 42.3728C52.1191 42.9303 49.889 45.718 50.4465 48.5057C50.8182 51.4792 53.6058 53.5235 56.5792 52.966C56.765 52.966 56.765 52.966 56.9508 52.7801C57.1367 53.3376 60.4817 73.9664 60.4817 73.9664",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1474 67.516C77.3242 70.2361 76.1474 74.0003 76.1474 74.0003C76.1474 74.0003 65.8242 69.4352 65.8242 60.2361C66.428 61.6727 67.3419 62.958 68.5006 64.0001C70.6044 65.9496 73.2732 67.1803 76.1219 67.5145L76.1474 67.516Z",
    fill: "#050C26"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5462 45.0742C55.1967 45.0742 54.8472 45.2662 54.6724 45.4582C54.3229 45.6502 54.1482 45.8422 53.9734 46.2261C53.7987 46.6101 53.6239 46.8021 53.6239 47.1861C53.6239 47.5701 53.6239 47.9541 53.6239 48.338C53.7987 49.8739 55.1967 50.8339 56.4199 50.6419L55.5462 45.0742Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5462 45.0742C55.1967 45.0742 54.8472 45.2662 54.6724 45.4582C54.3229 45.6502 54.1482 45.8422 53.9734 46.2261C53.7987 46.6101 53.6239 46.8021 53.6239 47.1861C53.6239 47.5701 53.6239 47.9541 53.6239 48.338C53.7987 49.8739 55.1967 50.8339 56.4199 50.6419",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1271 32.4923C67.4167 32.4923 62.0111 26.985 62.0111 20.3763C62.0111 13.7675 67.4167 8.26025 74.1271 8.26025C80.8375 8.26025 86.2432 13.7675 86.2432 20.3763C86.2432 26.985 80.8375 32.4923 74.1271 32.4923Z",
    fill: "#050C26"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3806 44.1422C53.8821 44.1422 48.4976 38.7366 48.4976 32.0262C48.4976 25.3158 53.8821 19.9102 60.3806 19.9102C66.8792 19.9102 72.2637 25.3158 72.2637 32.0262C72.2637 38.7366 67.0648 44.1422 60.3806 44.1422Z",
    fill: "#050C26"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3201 24.8085L78.3272 14.3457C78.3272 14.3457 100.204 -2.28265 108.992 15.6536C117.593 33.5898 86.5544 39.9422 73.8396 32.282C73.8396 32.282 69.1651 34.8977 65.9864 39.3817C64.3035 41.8106 63.3686 44.6131 63.3686 47.9762C63.3686 52.0866 58.6941 53.0207 58.3201 49.0972L57.9461 47.9762C57.5722 44.4263 51.5887 41.2501 51.4017 40.3159C50.2799 37.887 58.3201 24.8085 58.3201 24.8085Z",
    fill: "#050C26"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M153.542 177.726C153.674 177.858 161.072 185.926 164.508 191.481C165.036 192.275 165.829 192.672 166.754 192.672C167.282 192.672 167.678 192.54 168.207 192.275C169.396 191.481 169.792 189.894 169 188.704C165.3 182.62 157.769 174.419 157.373 174.155L153.542 177.726Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M153.542 177.726C153.674 177.858 161.072 185.926 164.508 191.481C165.036 192.275 165.829 192.672 166.754 192.672C167.282 192.672 167.678 192.54 168.207 192.275C169.396 191.481 169.792 189.894 169 188.704C165.3 182.62 157.769 174.419 157.373 174.155",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M156.977 173.89C157.109 174.023 164.375 181.826 167.81 187.514C168.339 188.307 169.132 188.704 170.056 188.704C170.585 188.704 170.981 188.572 171.51 188.307C172.699 187.514 173.095 185.927 172.302 184.736C168.603 178.652 161.204 170.584 160.808 170.319L156.977 173.89Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M156.977 173.89C157.109 174.023 164.375 181.826 167.81 187.514C168.339 188.307 169.132 188.704 170.056 188.704C170.585 188.704 170.981 188.572 171.51 188.307C172.699 187.514 173.095 185.927 172.302 184.736C168.603 178.652 161.204 170.584 160.808 170.319",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M160.279 169.79C160.411 169.922 167.414 177.726 170.849 183.281C171.377 184.075 172.17 184.471 173.095 184.471C173.623 184.471 174.02 184.339 174.416 184.075C175.605 183.281 176.001 181.694 175.209 180.503C171.509 174.419 164.375 166.351 163.978 165.954L160.279 169.79Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M160.279 169.79C160.411 169.922 167.414 177.726 170.849 183.281C171.377 184.075 172.17 184.471 173.095 184.471C173.623 184.471 174.02 184.339 174.416 184.075C175.605 183.281 176.001 181.694 175.209 180.503C171.509 174.419 164.375 166.351 163.978 165.954",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M162.658 164.633C162.79 164.765 169.793 172.436 173.228 178.124C173.756 178.917 174.549 179.314 175.474 179.314C176.002 179.314 176.399 179.182 176.795 178.917C177.984 178.124 178.38 176.537 177.588 175.346C173.888 169.262 166.225 160.797 165.829 160.4L162.658 164.633Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M162.658 164.633C162.79 164.765 169.793 172.436 173.228 178.124C173.756 178.917 174.549 179.314 175.474 179.314C176.002 179.314 176.399 179.182 176.795 178.917C177.984 178.124 178.38 176.537 177.588 175.346C173.888 169.262 166.225 160.797 165.829 160.4",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M155.26 155.503C154.996 154.71 154.996 153.652 155.656 152.99C156.581 151.932 158.167 151.8 159.224 152.593C159.356 152.593 163.848 156.297 173.493 159.207C174.814 159.603 175.606 161.058 175.21 162.381C174.946 163.571 173.757 164.233 172.7 164.233C172.436 164.233 172.171 164.233 171.907 164.1C167.151 162.646 163.451 161.058 160.809 159.736L159.224 158.942L155.26 155.503Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M155.26 155.503C154.996 154.71 154.996 153.652 155.656 152.99C156.581 151.932 158.167 151.8 159.224 152.593C159.356 152.593 163.848 156.297 173.493 159.207C174.814 159.603 175.606 161.058 175.21 162.381C174.946 163.571 173.757 164.233 172.7 164.233C172.436 164.233 172.171 164.233 171.907 164.1C167.151 162.646 163.451 161.058 160.809 159.736L159.224 158.942",
    stroke: "#050C26",
    strokeWidth: 0.86331,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-51-inside-1_227_12342",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 98C74.8366 98 82 105.163 82 114V139C82 147.837 74.8366 155 66 155H31.4L15.8793 169.782C14.606 170.994 12.5 170.092 12.5 168.333V154.616C5.34682 153.02 0 146.634 0 139V114C0 105.163 7.16344 98 16 98H66Z"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 98C74.8366 98 82 105.163 82 114V139C82 147.837 74.8366 155 66 155H31.4L15.8793 169.782C14.606 170.994 12.5 170.092 12.5 168.333V154.616C5.34682 153.02 0 146.634 0 139V114C0 105.163 7.16344 98 16 98H66Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4 155L30.7103 154.276L31 154H31.4V155ZM15.8793 169.782L15.1897 169.057H15.1897L15.8793 169.782ZM12.5 154.616L12.7178 153.64L13.5 153.815V154.616H12.5ZM81 114C81 105.716 74.2843 99 66 99V97C75.3888 97 83 104.611 83 114H81ZM81 139V114H83V139H81ZM66 154C74.2843 154 81 147.284 81 139H83C83 148.389 75.3888 156 66 156V154ZM31.4 154H66V156H31.4V154ZM15.1897 169.057L30.7103 154.276L32.0897 155.724L16.569 170.506L15.1897 169.057ZM13.5 168.333C13.5 169.213 14.553 169.664 15.1897 169.057L16.569 170.506C14.659 172.325 11.5 170.971 11.5 168.333H13.5ZM13.5 154.616V168.333H11.5V154.616H13.5ZM1 139C1 146.156 6.01188 152.144 12.7178 153.64L12.2822 155.592C4.68176 153.896 -1 147.113 -1 139H1ZM1 114V139H-1V114H1ZM16 99C7.71573 99 1 105.716 1 114H-1C-1 104.611 6.61116 97 16 97V99ZM66 99H16V97H66V99Z",
    fill: "#050C26",
    mask: "url(#path-51-inside-1_227_12342)"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 110.5,
    x2: 61.5,
    y2: 110.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 120.5,
    x2: 34.5,
    y2: 120.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 130.5,
    x2: 31.5,
    y2: 130.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 140.5,
    x2: 31.5,
    y2: 140.5,
    stroke: "#050C26",
    strokeLinecap: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-57-inside-2_227_12342",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 117C44.1634 117 37 124.163 37 133V158C37 166.837 44.1634 174 53 174H87.6L103.121 188.782C104.394 189.994 106.5 189.092 106.5 187.333V173.616C113.653 172.02 119 165.634 119 158V133C119 124.163 111.837 117 103 117H53Z"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 117C44.1634 117 37 124.163 37 133V158C37 166.837 44.1634 174 53 174H87.6L103.121 188.782C104.394 189.994 106.5 189.092 106.5 187.333V173.616C113.653 172.02 119 165.634 119 158V133C119 124.163 111.837 117 103 117H53Z",
    fill: "#E86E4D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6 174L88.2897 173.276L88 173H87.6V174ZM103.121 188.782L103.81 188.057H103.81L103.121 188.782ZM106.5 173.616L106.282 172.64L105.5 172.815V173.616H106.5ZM38 133C38 124.716 44.7157 118 53 118V116C43.6112 116 36 123.611 36 133H38ZM38 158V133H36V158H38ZM53 173C44.7157 173 38 166.284 38 158H36C36 167.389 43.6112 175 53 175V173ZM87.6 173H53V175H87.6V173ZM103.81 188.057L88.2897 173.276L86.9103 174.724L102.431 189.506L103.81 188.057ZM105.5 187.333C105.5 188.213 104.447 188.664 103.81 188.057L102.431 189.506C104.341 191.325 107.5 189.971 107.5 187.333H105.5ZM105.5 173.616V187.333H107.5V173.616H105.5ZM118 158C118 165.156 112.988 171.144 106.282 172.64L106.718 174.592C114.318 172.896 120 166.113 120 158H118ZM118 133V158H120V133H118ZM103 118C111.284 118 118 124.716 118 133H120C120 123.611 112.389 116 103 116V118ZM53 118H103V116H53V118Z",
    fill: "#050C26",
    mask: "url(#path-57-inside-2_227_12342)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1804 148.386V147.159L66.0099 138.3V140.038L52.9702 147.786L53.098 147.555V147.99L52.9702 147.76L66.0099 155.507V157.246L51.1804 148.386ZM81.1623 130.591L72.7248 161.938H71.229L79.6665 130.591H81.1623ZM101.201 148.386L86.3718 157.246V155.507L99.4116 147.76L99.271 147.99V147.555L99.4116 147.786L86.3718 140.038V138.3L101.201 147.159V148.386Z",
    fill: "#050C26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateHtmlPreview);
export default __webpack_public_path__ + "static/media/create-html-preview.9240dac9e11cb1c41d96215c0425b957.svg";
export { ForwardRef as ReactComponent };